<template>
  <div class="form-card">
    <div class="title">
      {{ data.prompt }}
    </div>
    <div class="btn" @click="handleClick">
      <span>{{ data.card_name }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions(["checkLogin"]),
    handleClick() {
      if (this.data.card_name === "人工客服") {
        this.checkLogin()
          .then(() => {
            this.$emit("imChat");
          })
          .catch((err) => {
            this.$eventBus.$emit("showLogin");
          });
        return;
      }
      if (this.data.url) {
        this.checkLogin()
          .then(() => {
            const session_id = sessionStorage.getItem("im_sess_uuid");
            let url = this.data.url;
            if (session_id) {
              if (url.indexOf("?") === -1) {
                url += "?session_id=" + session_id;
              } else {
                url += "&session_id=" + session_id;
              }
            }
            window.open(url);
          })
          .catch((err) => {
            this.$eventBus.$emit("showLogin");
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.form-card {
  margin: 7.5px 0;
  padding: 12px;
  background: #ffffff;
  border-radius: 0px 10px 10px 10px;
  .title {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    background-color: @gold;
  }
}
</style>
